import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { MsalProvider } from '@azure/msal-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { msalInstance } from '@/lib/msalInstance'

import App from './App.tsx'

import './index.css'

const queryClient = new QueryClient()

// Inicializar MSAL antes de renderizar para que handleRedirectPromise procese
// el callback de vuelta desde el portal de Microsoft (si se usa loginRedirect).
msalInstance.initialize().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </MsalProvider>
    </StrictMode>
  )
})
